// src/app/core/http-loading.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { TRACK_LOADING } from '../tokens/http-loading.token';

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  constructor(private loading: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldTrack = req.context.get(TRACK_LOADING);

    if (!shouldTrack) return next.handle(req);

    this.loading.start();
    return next.handle(req).pipe(finalize(() => this.loading.stop()));
  }
}
